<template>
<div class="chapter">
<div class="inner_page">
<p><a id="cop"></a></p>
<div> <br/></div><div class="crt">Overlook Duckworth Peter Mayer Publishers, Inc. <br/>New York &amp; London</div>
<div> <br/></div><div class="crt">NEW YORK: <br/>The Overlook Press <br/>141 Wooster Street <br/>New York, NY 10012  <br/><a href="http://www.overlookpress.com" target="_blank">www.overlookpress.com</a></div>
<div> <br/></div><div class="crt">LONDON: <br/>Duckworth <br/>90-93 Cowcross Street <br/>London EC1M 6BF <br/>inquiries@duckworth-publishers.co.uk  <br/><a href="http://www.ducknet.co.uk" target="_blank">www.ducknet.co.uk</a></div>
<div class="crt"><div> <br/></div>Copyright © 2008 by Rohan Kriwaczek</div>
<div> <br/></div><div class="crt">All Rights Reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system now known or to be invented without permission in writing from the publisher, except by a reviewer who wishes to quote brief passages in connection with a review written for inclusion in a magazine, newspaper, or broadcast.</div>
<div> <br/></div><div class="crt">Cataloging-in-Publication Data is available from the Library of Congress</div>
<div> <br/></div>
<div class="crt">eISBN : 978-1-590-20610-2</div>
<div class="crt">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kriw_9781590206102_oeb_cop_r1.vue?560cb900